/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ cost: NonNullable<unknown> }} Creditcostonly2Inputs */

const en_creditcostonly2 = /** @type {(inputs: Creditcostonly2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Costs ${i?.cost} credits`)
};

const de_creditcostonly2 = /** @type {(inputs: Creditcostonly2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kostet ${i?.cost} Credits`)
};

/**
* | output |
* | --- |
* | "Costs {cost} credits" |
*
* @param {Creditcostonly2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditcostonly2 = /** @type {((inputs: Creditcostonly2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditcostonly2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditcostonly2(inputs)
	return de_creditcostonly2(inputs)
});
export { creditcostonly2 as "creditCostOnly" }